// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9562 ? "3975359d" : chunkId) + "." + {"981":"039c7a4642c71dca","9562":"bca2da053e7aa6ca"}[chunkId] + ".js";
};